import { Link } from 'react-router-dom'
import { useLocale } from '../locale/LocaleContext.js'

export function SupportPage() {
  const { t } = useLocale()
  const linkClass = 'underline underline-offset-4 hover:text-[var(--xr-brand-primary)]'

  return (
    <div className="h-full overflow-y-auto bg-[var(--xr-bg-canvas)]">
      <div className="mx-auto w-full max-w-3xl px-4 py-8 sm:py-12">
        <article className="space-y-6 text-[13px] leading-relaxed text-[var(--xr-text-primary)]">
          <header>
            <h1 className="text-[22px] font-semibold tracking-tight">{t('support.title')}</h1>
            <p className="mt-4 text-[var(--xr-text-muted)]">{t('support.intro')}</p>
          </header>

          <section className="space-y-2">
            <h2 className="text-[15px] font-semibold">{t('support.contactTitle')}</h2>
            <p>{t('support.operator')}</p>
            <p>
              <a href="mailto:support@xingroute.com" className={linkClass}>
                support@xingroute.com
              </a>
            </p>
            <a
              href="mailto:support@xingroute.com"
              className="inline-flex min-h-11 items-center rounded-[var(--xr-radius-md)] bg-[var(--xr-brand-primary)] px-4 font-medium text-[var(--xr-brand-primary-ink)]"
            >
              {t('support.emailAction')}
            </a>
          </section>

          <section className="space-y-2">
            <h2 className="text-[15px] font-semibold">{t('support.feedbackTitle')}</h2>
            <p>{t('support.feedbackIntro')}</p>
            <ul className="list-disc space-y-1 pl-5">
              <li>{t('support.deviceDetails')}</li>
              <li>{t('support.reproduction')}</li>
              <li>{t('support.attachments')}</li>
            </ul>
            <p className="text-[var(--xr-text-muted)]">{t('support.sensitiveData')}</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-[15px] font-semibold">{t('support.dataTitle')}</h2>
            <p>{t('support.dataDescription')}</p>
            <Link to="/privacy" className={linkClass}>
              {t('support.privacy')}
            </Link>
          </section>

          <section className="space-y-2">
            <h2 className="text-[15px] font-semibold">{t('support.documentsTitle')}</h2>
            <Link to="/terms" className={linkClass}>
              {t('support.terms')}
            </Link>
          </section>
        </article>

        <div className="mt-10 text-[12px] text-[var(--xr-text-muted)]">
          <Link to="/discover" className={linkClass}>
            {t('support.back')}
          </Link>
        </div>
      </div>
    </div>
  )
}
